import React, {useEffect} from 'react'
import './main.css'
import Categories from '../../components/Categories/Categories'
import { useGetProductsQuery } from '../../features/products/productsApiSlice'
import { useAppDispatch } from '../../hooks/redux'
import { setProductsAction } from '../../features/products/productsSlice'
import Slider from "../../components/Slider/Slider";
import ModelsBar from "../../components/ModelsSlider/ModelsBar";
import TopSellingProducts from "../../components/Products/TopSellingProducts";
import useScrollTop from "../../hooks/useScrollTop";

const Main = () => {
    const dispatch = useAppDispatch()
    const { data: allProducts, isSuccess } = useGetProductsQuery()

    useEffect(() => {
        if (isSuccess) {
            dispatch(setProductsAction({products: allProducts}))
        }
    }, [isSuccess])

    useScrollTop()

    return (
        <div className="main">
            <Slider/>
            <ModelsBar/>
            <Categories />
            {isSuccess && <TopSellingProducts />}
        </div>
    )
}

export default Main
